import React, { useMemo } from 'react';
import { IconButton, Typography } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    eachDayOfInterval,
} from 'date-fns';
import { uk } from 'date-fns/locale';
import CalendarDay from './CalendarDay';
import { getWeekdayLabels, getMonthNames } from '../utils/datePresets';
import { useStyles } from '../styles';

const Calendar = ({
    currentMonth,
    onPreviousMonth,
    onNextMonth,
    onDateClick,
    onDateHover,
    isInRange,
    isRangeStart,
    isRangeEnd,
    disableFuture = false
}) => {
    const classes = useStyles();
    const monthNames = getMonthNames();
    const weekdayLabels = getWeekdayLabels();

    const calendarDays = useMemo(() => {
        const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(currentMonth);

        const calendarStart = startOfWeek(monthStart, { locale: uk });

        const calendarEnd = endOfWeek(monthEnd, { locale: uk });

        return eachDayOfInterval({ start: calendarStart, end: calendarEnd });
    }, [currentMonth]);

    const monthName = monthNames[currentMonth.getMonth()];
    const year = currentMonth.getFullYear();

    return (
        <div className={classes.calendarSection}>
            <div className={classes.calendarHeader}>
                <IconButton
                    onClick={onPreviousMonth}
                    className={classes.navigationButton}
                    size="small"
                >
                    <ChevronLeftIcon />
                </IconButton>

                <Typography className={classes.monthYearLabel}>
                    {monthName} {year}
                </Typography>

                <IconButton
                    onClick={onNextMonth}
                    className={classes.navigationButton}
                    size="small"
                >
                    <ChevronRightIcon />
                </IconButton>
            </div>

            <div className={classes.weekdaysRow}>
                {weekdayLabels.map((label, index) => (
                    <div key={index} className={classes.weekdayLabel}>
                        {label}
                    </div>
                ))}
            </div>

            <div className={classes.daysGrid}>
                {calendarDays.map((date, index) => {
                    const disabled = disableFuture && date > new Date();

                    return (
                        <CalendarDay
                            key={index}
                            date={date}
                            currentMonth={currentMonth}
                            onClick={onDateClick}
                            onMouseEnter={onDateHover}
                            isInRange={isInRange(date)}
                            isRangeStart={isRangeStart(date)}
                            isRangeEnd={isRangeEnd(date)}
                            disabled={disabled}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Calendar;
